import React, { PureComponent } from "react";
import { Button } from "antd";
import styled, { css } from "styled-components";

const ButtonStyled = styled(Button)`
  ${props =>
    props.ghost &&
    css`
      border-color: ${props.bordercolor} !important;
      .ghost-effect {
        background-color: ${props.bordercolor} !important;
      }
      &:hover {
        span {
          color: ${props.hoverfontcolor} !important;
        }
      }
    `};
`;

export default class MyButton extends PureComponent {
  static defaultProps = {
    bordercolor: "#ffffff",
    hoverfontcolor: "#000000"
  };
  render() {
    const { children, ghost } = this.props;
    return (
      <ButtonStyled {...this.props}>
        {ghost && <div className="ghost-effect" />}
        {children}
      </ButtonStyled>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Button.js